import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Translator } from 'ggApp/modules/translator/components';
import { LayoutComponent_Button as LayoutComponentButton } from 'ggApp/modules/layout';

import styles from './index.module.scss';

export default class FormsPhoneVerificationConfirmPhone extends PureComponent {
    render() {
        const {
            confirmPhone,
            authFetching,
            reqMark,
            dark,
            authPhoneVerification,
            label,
            resetAsyncValidation,
            disabled,
            phone: { verificationCode, isVerified },
        } = this.props;

        const asyncError = authPhoneVerification.asyncErrors.confirmPhoneError;

        const errorCondition =
            !!asyncError ||
            (verificationCode.meta.touched && !!verificationCode.meta.error) ||
            (isVerified.meta.touched && !!isVerified.meta.error);
        const buttonValid = !asyncError || verificationCode.meta.valid;

        return (
            <div
                className={`${styles.formsPhoneVerificationConfirmPhone} ${
                    disabled ? styles['formsPhoneVerificationConfirmPhone--disabled'] : ''
                } ${dark ? styles['formsPhoneVerificationConfirmPhone--dark'] : ''}`}
            >
                {label && (
                    <div className={styles.formsPhoneVerificationConfirmPhone__label}>{label}</div>
                )}
                <div className={styles.formsPhoneVerificationConfirmPhone__wrap}>
                    <div className={styles.formsPhoneVerificationConfirmPhone__boxWrap}>
                        <div
                            className={cn(styles.formsPhoneVerificationConfirmPhone__box, {
                                [styles['formsPhoneVerificationConfirmPhone__box--input']]: true,
                                [styles['formsPhoneVerificationConfirmPhone__box--active']]:
                                    verificationCode.meta.active ||
                                    verificationCode.input.value.length !== 0,
                                [styles['formsPhoneVerificationConfirmPhone__box--error']]:
                                    !!asyncError ||
                                    (verificationCode.meta.touched &&
                                        !!verificationCode.meta.error),
                                [styles['formsPhoneVerificationConfirmPhone__box--valid']]:
                                    !asyncError && verificationCode.meta.valid,
                            })}
                        >
                            <div className={styles.formsPhoneVerificationConfirmPhone__label}>
                                <div>
                                    <Translator tk="FORM_LABEL_PHONE_VERIFICATION" />{' '}
                                    {reqMark ? '*' : ''}
                                </div>
                            </div>
                            <input
                                id="phoneVerificationCodeInput"
                                {...verificationCode.input}
                                type="text"
                                onChange={(e) => {
                                    resetAsyncValidation({ confirmPhoneError: '' });
                                    verificationCode.input.onChange(e.target.value);
                                }}
                            />
                        </div>
                    </div>

                    <LayoutComponentButton
                        dark={dark}
                        className={styles.formsPhoneVerificationConfirmPhone__button}
                        disabled={!buttonValid}
                        autoWidth
                        noArrow
                        inputSize
                        noBorderMobile
                        tk="CONFIRM_PHONE"
                        type="button"
                        loading={authFetching}
                        onClick={() => confirmPhone(verificationCode.input.value)}
                    />
                </div>

                {errorCondition && (
                    <div className={styles.formsPhoneVerificationConfirmPhone__error}>
                        {asyncError || (
                            <Translator tk={verificationCode.meta.error || isVerified.meta.error} />
                        )}
                    </div>
                )}

                <div className={styles.formsPhoneVerificationConfirmPhone__note}>
                    <Translator tk="PHONE_VERIFICATION_NOTE" />
                </div>
            </div>
        );
    }
}
